<template>
  <div class="s-chatPushPrompt u-marginBottom2">
    <div class="o-flex -alignCenter -spaceBetween -gap3">
      <div class="o-flex -alignCenter -gap2">
        <SvgIcon
          type="info"
          small
          class="u-colorDarkMediumEmphasis o-flex__item -noShrink" />
        <div>
          <div class="t-body3 u-colorDark">{{ $t('chat.push_prompt.title') }}</div>
          <div class="t-caption1 u-colorDarkMediumEmphasis">{{ $t('chat.push_prompt.description') }}</div>
        </div>
      </div>
      <div class="o-flex -alignCenter -gap2">
        <button
          class="c-button -success t-noWrap"
          @click="enable">
          {{ $t('chat.push_prompt.enable') }}
        </button>
        <button
          class="c-button -flat t-noWrap"
          @click="dismiss">
          {{ $t('chat.push_prompt.not_now') }}
        </button>
      </div>
    </div>
    <BrowserNotificationTutorialModal v-model="showTutorial" />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import api from '@/logic/api'
import { useChatStore } from '@/modules/chat/chatStore'
import { subscribePushNotification } from '@/modules/global/logic/pushNotification'
import ProfileAPI from '@/modules/profile/api/profile'
import BrowserNotificationTutorialModal from '@/modules/profile/components/BrowserNotificationTutorialModal.vue'
import store from '@/store'

const chatStore = useChatStore()
const showTutorial = ref(false)

const enable = async () => {
  if (Notification?.permission === 'denied') {
    showTutorial.value = true
    return
  }
  // Just hide the prompt so the user gets immediate feedback. Then, we update the settings in the background.
  chatStore.hideNotificationPrompt(true)
  try {
    await Promise.all([
      subscribePushNotification(),
      store.dispatch('profile/updateNotificationSettings'),
    ])
  } finally {
    if (Notification?.permission === 'granted') {
      // Also ensure that the global push notification setting is enabled, otherwise the user would still not get notifications.
      try {
        const currentlyDisabled = store.getters['profile/getNotificationSetting']('all', 'push_disabled')
        if (currentlyDisabled !== false) {
          await ProfileAPI.saveNotificationSettings([{ notification: 'all', push_disabled: false }])
          store.commit('profile/setNotificationSetting', { notification: 'all', setting: 'push_disabled', value: false })
        }
      } catch (e) {
        // Do not block UX if persisting the setting fails
        // eslint-disable-next-line no-console
        console.error('Failed to enable global push notification setting', e)
      }
    } else {
      store.commit('notifications/addError', { title: api.i18n.t('chat.push_prompt.failed_to_enable') })
    }
  }
}

const dismiss = () => {
  chatStore.hideNotificationPrompt(true)
}
</script>

<style scoped lang="scss">
@import '@/assets/scss/config';

.s-chatPushPrompt {
  flex-shrink: 0;
  border-bottom: 1px solid $color-divider;
  background: $color-soft-highlight;
  padding: $spacing-2;
}
</style>
